import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import {UserContextCriteria, UserContext, UserContextWrapper} from '@wizeoo/akm-message-lib';
import { Model } from '../../../model/model';
import { CtxtEntry } from '../../../manager/context/user-context.service';
import { ExternalAPI } from '../../../model/external-api';

/**
 * Appels contexte utilisateur (Find)
 * chargement complet sur retour de login.
 * Author LMA
 */
export class UserContextCmd extends WizCommand<UserContextWrapper> {

  protected model: Model = null;
  constructor(model: Model) {
    super();
    this.model = model;
  }

  /** retourne un wrapper pre-alimenté */
  public wrapper(): UserContextWrapper {
    const wrapper: UserContextWrapper = new UserContextWrapper();
    wrapper.criteria = new UserContextCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.criteria.vision = this.model.visionCode;
    return wrapper;
    
  }

  /** mémorisation des données d'entrée */
  public revNumber: number = 0;
  public toDeleteEntry: CtxtEntry = null; // qui supprimer
  public entriesToSave: Map<string, CtxtEntry> = null; // quoi sauver
  
  /**
   * collecte incrémentielle des entrées de contexte
   * @param pUserId id bdd
   * @param pCallback callback
   * @param pRevNumber pour collecte incrémentielle
   * @param pLoadLastVision chargement de la dernière vision de connexion uniquement
   * @returns
   */
  public getContext(pLogin: string, pCallback: Function, pRevNumber: number = null): UserContextCmd {
    this.callback = pCallback;
    const wrapper: UserContextWrapper = this.wrapper();
    wrapper.method = WIZ_COMMAND_METHOD.GET;
    wrapper.criteria.login=pLogin;
    wrapper.criteria.revisionNumber = pRevNumber;

    this.configureRemote(ExternalAPI.USER_CONTEXT_API, wrapper, pCallback);
    this.doLock = false; // ici, parce que configureRemote écrase...
    return this;
  }

  /**
   * suppression d'une entrée de contexte
   */
  public deleteContext(toDie: CtxtEntry, pCallback: Function): UserContextCmd {
    this.toDeleteEntry = toDie;
    const wrapper: UserContextWrapper = this.wrapper();
    wrapper.entity = this.model.userContextService.ctxtEntryToRemote(toDie, 0);
    wrapper.method = WIZ_COMMAND_METHOD.DELETE;

    this.configureRemote(ExternalAPI.USER_CONTEXT_API, wrapper, pCallback);
    this.doLock = false; // ici, parce que configureRemote écrase...
    return this;
  }

  /**
   * mise à jour d'un pool d'éléments de contexte (une vue, les tabs...)
   */
  public updateContext(pLogin: string, entriesToSave: Map<string, CtxtEntry>, revNumber: number, pCallback: Function): UserContextCmd {
    this.revNumber = revNumber;
    this.entriesToSave = entriesToSave;

    const wrapper: UserContextWrapper = this.wrapper();
    wrapper.criteria.login=pLogin;
    wrapper.method = WIZ_COMMAND_METHOD.UPDATE;

    const castEntries: UserContext[] = [];
    [...entriesToSave.values()].forEach((ctxt: CtxtEntry) => {
      const uctxt: UserContext =  this.model.userContextService.ctxtEntryToRemote(ctxt, revNumber);
      
      if( uctxt.widgetId && !uctxt.tabId) { // contrôle contexte valide
        // console.log('missing tabId on widget', uctxt);
      } else {
        castEntries.push(uctxt);
      }
    });

    wrapper.entities = castEntries;

    this.configureRemote(ExternalAPI.USER_CONTEXT_API, wrapper, pCallback);
    this.doLock = false; // ici, parce que configureRemote écrase...
    
    if(castEntries.length > 0) {
      return this;
    } else { // contexte mal formé
      return null; 
    }

    // return this;
  }


  public wizResult(): void {
    // console.log('uc result', this.result, this);
    
    // mise à jour des IDs sur les entrées de contexte
    if (this.result?.method === WIZ_COMMAND_METHOD.UPDATE) {
      this.result.entities?.forEach((uc: UserContext) => {
        this.entriesToSave.get(uc.contextKey).id = uc.id; // pas d'optimistic lock sur les contextes
      });
    }
  }
}
